import { CSInterface } from "csinterface-ts";
import {jsxConstsEvents, jsxConstFunctions} from '../jsxConsts';
;

const { csInterface }: { csInterface: CSInterface } = window as any;

export function renderImageProcessListener(){
  csInterface.addEventListener(jsxConstsEvents.imageProcess, (data: any) => {
    const result: any = {};
    const eScript = jsxConstFunctions.imageProcessed.replace('%VALUE%', (result.extension === "jpg").toString());
    csInterface.evalScript(eScript, (res) => {console.log('')});
  });
}